import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

/**
 * A controller that is used to setup the tabs view for an individual Fulfilment Request
 */
export class FulfilmentRequestController {
  public static $inject = [
    'ACTToolbarService',
    'fulfilmentRequest',
    '$state'
  ];

  public fulfilmentRequestObject: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequest;

  constructor(
    private toolbarService: ACTToolbarService,
    public fulfilmentRequestResponse: InterACT.Interfaces.FulfilmentRequests.FulfilmentRequestResponse,
    private $state: ng.ui.IStateService) {
    this.activate();
  }

  /**
   * Setups the toolbar title and tabs
   */
  private activate = () => {
    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      this.fulfilmentRequestObject = this.fulfilmentRequestResponse.fulfilmentRequest;
      const fulfilmentRequestExternalId: string = this.fulfilmentRequestObject.externalId;
      toolbar.setTitle('HEADING.FULFILMENT_REFERENCE', {reference: fulfilmentRequestExternalId});

      toolbar.setTabs([
        {
          label: 'SUMMARY',
          sref: 'fulfilment-request.summary'
        },
        {
          label: 'TIMELINE.TITLE',
          sref: 'fulfilment-request.timeline'
        },
        {
          label: 'DETAILS',
          sref: 'fulfilment-request.details'
        }
      ], this.$state.current.data.selectedTab);
    });
  }
}
